import { render, staticRenderFns } from "./CookiesBar.vue?vue&type=template&id=58218abf&scoped=true&"
import script from "./CookiesBar.vue?vue&type=script&lang=js&"
export * from "./CookiesBar.vue?vue&type=script&lang=js&"
import style0 from "./CookiesBar.vue?vue&type=style&index=0&id=58218abf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58218abf",
  null
  
)

export default component.exports